import { Component, ViewChild, } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { TicketManagementModel } from "@app/models/ticketManagement/TicketManagementModel";
import { TransactionHistoryService } from "@app/services/transactionHistory/transactionHistory.service";
import { Router } from "@angular/router";
import { TicketCountModel, HelpDeskModel } from "@app/models/merchant-settlement-model/merchant-settlement-model";
import { DynamicFlow_Column, ChartData } from "@app/models/dashboard/dynamicDashboard";
@Component({
    selector: 'ticketManagement',
    templateUrl: './ticketManagement.component.html',
})
export class TicketManagementComponent {
    helpdesk=new HelpDeskModel();
    ticketManagementModel = new TicketManagementModel();
    raiseTicketDataForNavigation = new TicketManagementModel();
    ticketManagementList = new Array<TicketManagementModel>();
    errorMessage: string;
    errorMessageMerchantCode: string;
    status: boolean = false;
    statusSerialNo: boolean = false;
    statusMerchantCode: boolean = false;
    errorMessageSerialNo: string;
    isMerchantWise: boolean = false;
    isTerminalWise: boolean = false;
    isOutletWise: boolean = false;
    ticketCount = new TicketCountModel();
    showFilter: boolean = true;
    chartStatusWise: DynamicFlow_Column = new DynamicFlow_Column();
    EntityTypeId: string = "0";
    IsTicketDetails:boolean=false;

    chartIssueWise: DynamicFlow_Column = new DynamicFlow_Column();
    constructor(private transactionhistoryService: TransactionHistoryService, private toastr: ToastrService, private router: Router) { }

    ngOnInit() {
        this.EntityTypeId = localStorage.getItem('EntityType');
        if (this.EntityTypeId == '115') {
            this.isMerchantWise = true;
        }
        else {
            this.getRaiseTicketList();
            this.isOutletWise = true;
        }
        
        this.generateIssueWiseCharts();
    }
    generateIssueWiseCharts() {
        this.chartStatusWise = new DynamicFlow_Column();
        this.chartStatusWise.Chart_Type = "pie";
        this.chartStatusWise.Column_Type = "Chart";
        let statusWiseData: Array<ChartData> = new Array<ChartData>();
        let openChartStatus: ChartData = new ChartData();
        openChartStatus.data = [10, 5, 6];
        //   openChartStatus.label ='Open Tickets';
        statusWiseData.push(openChartStatus);

        this.chartStatusWise.DataColumns_DataSet = statusWiseData;
        this.chartStatusWise.DataColumns_Heading = ['Open', 'Closed', 'InProgress'];

        this.chartIssueWise = new DynamicFlow_Column();
        this.chartIssueWise.Column_Type = "Chart";
        this.chartIssueWise.Chart_Type = "bar";

        let issueWiseData: Array<ChartData> = new Array<ChartData>();
        let issueData: ChartData = new ChartData();
        issueData.data = [10, 5, 6, 0, 5, 3, 0];
        //   openChartStatus.label ='Open Tickets';
        issueWiseData.push(issueData);

        this.chartIssueWise.DataColumns_DataSet = issueWiseData;
        this.chartIssueWise.DataColumns_Heading = ['Txn Not Accepted', 'UnAware of Program', 'Issuer Not Available', 'Wallet Not Working', 'Settlement Problem', 'Merchant Feedback', 'Other'];
        this.chartIssueWise.XHeading = 'Issue Type';
        this.chartIssueWise.YHeading = 'Count';
    }
    navigateToRaiseTicket() {
        if (this.EntityTypeId == '115') {
            if (this.isMerchantWise == true)
                this.router.navigate(['/secure/admin/raiseTicket/' + this.raiseTicketDataForNavigation.MerchantCode + '/' + 0 + '/' + this.raiseTicketDataForNavigation.CityId + '/' + this.raiseTicketDataForNavigation.StateId + '/' + 0]);
            else if (this.isTerminalWise == true)
                this.router.navigate(['/secure/admin/raiseTicket/' + this.raiseTicketDataForNavigation.MerchantCode + '/' + this.raiseTicketDataForNavigation.OutletId + '/' + this.raiseTicketDataForNavigation.CityId + '/' + this.raiseTicketDataForNavigation.StateId + '/' + this.raiseTicketDataForNavigation.TerminalId]);
            else if (this.isOutletWise == true)
                this.router.navigate(['/secure/admin/raiseTicket/' + this.raiseTicketDataForNavigation.MerchantCode + '/' + this.raiseTicketDataForNavigation.OutletId + '/' + this.raiseTicketDataForNavigation.CityId + '/' + this.raiseTicketDataForNavigation.StateId + '/' + 0]);
        }
        else {
            if (this.isTerminalWise == true)
                this.router.navigate(['/app/merchant/raiseTicket/' + this.raiseTicketDataForNavigation.OutletId + '/' + this.raiseTicketDataForNavigation.CityId + '/' + this.raiseTicketDataForNavigation.StateId + '/' + this.raiseTicketDataForNavigation.TerminalId]);
            else if (this.isOutletWise == true)
                this.router.navigate(['/app/merchant/raiseTicket/' + this.raiseTicketDataForNavigation.OutletId + '/' + this.raiseTicketDataForNavigation.CityId + '/' + this.raiseTicketDataForNavigation.StateId + '/' + 0]);
        }
    }

    getRaiseTicketList() {
        this.ticketManagementModel.IsMerchantWise = this.isMerchantWise;
        this.ticketManagementModel.IsOutletWise = this.isOutletWise;
        this.ticketManagementModel.IsTerminalWise = this.isTerminalWise;
        this.transactionhistoryService.getRaiseTicketList(this.ticketManagementModel).subscribe(data => {
            this.ticketManagementList = JSON.parse(JSON.stringify(data));
            this.getTicketCount();
        });
    }
    getDetailsForRaiseTicket(list){
        this.raiseTicketDataForNavigation.CityId=list.CityId;
        this.raiseTicketDataForNavigation.StateId=list.StateId;
        if(this.isMerchantWise==true)
        this.raiseTicketDataForNavigation.MerchantCode=list.Code
        if(this.isOutletWise==true)
        this.raiseTicketDataForNavigation.OutletId=list.Id
        if(this.isTerminalWise==true)
        this.raiseTicketDataForNavigation.TerminalId=list.Id
        this.transactionhistoryService.getDetailsForRaiseTicket(this.raiseTicketDataForNavigation).subscribe(data => {
            this.raiseTicketDataForNavigation = JSON.parse(JSON.stringify(data));
            
            if(this.IsTicketDetails==true)
            this.navigateToHelpDesk();
            else
            this.navigateToRaiseTicket();

        });
    }
    navigateToHelpDesk() {

        if (this.EntityTypeId == '115') {
            if (this.isMerchantWise == true)
                this.router.navigate(['/secure/admin/HelpDesk/' + this.raiseTicketDataForNavigation.MerchantCode + '/' + this.raiseTicketDataForNavigation.OutletId + '/' + this.raiseTicketDataForNavigation.TerminalNumber]);
            else if (this.isTerminalWise == true)
                this.router.navigate(['/secure/admin/HelpDesk/' + this.raiseTicketDataForNavigation.MerchantCode + '/' + this.raiseTicketDataForNavigation.OutletId + '/' + this.raiseTicketDataForNavigation.TerminalNumber]);
            else if (this.isOutletWise == true)
                this.router.navigate(['/secure/admin/HelpDesk/' + this.raiseTicketDataForNavigation.MerchantCode + '/' + this.raiseTicketDataForNavigation.OutletId + '/' + 0]);
        }
        else {
            if (this.isTerminalWise == true)
                this.router.navigate(['/app/merchant/HelpDesk/' + this.raiseTicketDataForNavigation.OutletId + '/' + this.raiseTicketDataForNavigation.TerminalNumber]);
            else if (this.isOutletWise == true)
                this.router.navigate(['/app/merchant/HelpDesk/' + this.raiseTicketDataForNavigation.OutletId + '/' + 0]);
        }
    }
    navigateToTerminalDetail(list) {
        this.router.navigate(['/app/merchant/terminalDetail/' + list.OutletId]);
    }
    isNumberValidation(event: any) {
        const pattern = /[0-9\ ]/;
        let inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar) && event.keyCode != 8) {
            this.errorMessage = "Enter only numbers";
            this.status = true;
            event.preventDefault();
        }

        else {
            this.errorMessage = " ";
            this.status = false;
        }
    }
    isNumberValidationMerchantCode(event: any) {
        const pattern = /[0-9\ ]/;
        let inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar) && event.keyCode != 8) {
            this.errorMessageMerchantCode = "Enter only numbers";
            this.statusMerchantCode = true;
            event.preventDefault();
        }

        else {
            this.errorMessage = " ";
            this.errorMessageMerchantCode = " ";
            this.statusMerchantCode = false;
        }
    }
    isNumberValidationSerialNo(event: any) {
        const pattern = /[0-9\ ]/;
        let inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar) && event.keyCode != 8) {
            this.statusSerialNo = true;
            this.errorMessageSerialNo = "Enter only numbers";
            event.preventDefault();
        }

        else {
            this.statusSerialNo = false;
            this.errorMessageSerialNo = " ";
        }
    }

    getTerminalByMerchantCode() {
        this.isOutletWise = false
        this.isTerminalWise = true;
        this.isMerchantWise = false;
        if (this.ticketManagementList.length != 0)
            this.getRaiseTicketList();
    }
    getOutletlByMerchantCode() {
        this.isOutletWise = true;
        this.isTerminalWise = false;
        this.isMerchantWise = false;
        if (this.ticketManagementList.length != 0)
            this.getRaiseTicketList();
    }
    getMerchantlByMerchantCode() {
        this.isMerchantWise = true;
        this.isOutletWise = false
        this.isTerminalWise = false;
        if (this.ticketManagementList.length != 0)
            this.getRaiseTicketList();

    }
    getTicketCount() {
        // debugger
        this.helpdesk.MerchantCode=this.ticketManagementModel.MerchantCode;
        this.transactionhistoryService.getTicketCount(this.helpdesk).subscribe(data => {
            this.ticketCount = JSON.parse(JSON.stringify(data));
        });
    }
    extraCssAsPerSelection(status: string) {
        switch (status) {
            case 'merchant':
                {
                    if (this.isMerchantWise)
                        return "daily_btn_active";
                    break;
                }
            case 'outlet':
                {
                    if (this.isOutletWise)
                        return "daily_btn_active";
                    break;
                }
            case 'terminal':
                {
                    if (this.isTerminalWise)
                        return "daily_btn_active";
                    break;
                }
        }
    }
    showHideFilter() {
        this.showFilter = !this.showFilter;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/common/help-desk/ticketManagement.component.ts